/**
 * Sidebar navigation items for the Equipments module.
 * Provides navigation to equipment management and out of service tracking.
 * Navigation items are feature-flag gated.
 */
import { FireTruck, FireTruckOutlined } from '@mui/icons-material';

import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';
import { NavItemType } from '@/common/presentation/components/layout/Sidebar/type';
import { useFilterNavItemsByFeatureFlags } from '@/common/presentation/utils/filterNavItems';

export interface EquipmentNavItemsResult {
  item: NavItemType | null;
  isReady: boolean;
}

const EquipmentNavItems = (): EquipmentNavItemsResult => {
  const navItems: NavItemType = {
    id: 'equipment',
    title: 'Equipment',
    type: 'collapse',
    icon: FireTruckOutlined,
    iconSelected: FireTruck,
    url: '/equipment?module=equipment',
    featureFlag: FEATURE_FLAGS.EQUIPMENT_MODULE_ENABLED,
    children: [
      {
        id: 'equipment_management',
        title: 'Management',
        type: 'item',
        url: '/equipment?module=equipment&submodule=equipment_management'
      },
      {
        id: 'outOfService',
        title: 'Out of Service',
        type: 'item',
        url: '/equipment?module=equipment&submodule=outOfService',
        featureFlag: FEATURE_FLAGS.EQUIPMENT_OUT_OF_SERVICE_TAB
      }
    ]
  };

  const { items: filteredItems, isReady } = useFilterNavItemsByFeatureFlags([navItems]);
  return {
    item: filteredItems[0] ?? null,
    isReady
  };
};

export default EquipmentNavItems;
